import axios from "axios"
import { env } from "../constants"

/* All */
export const all = (data) => {
    const uri = `${env.startpoint}dashboard/all`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}